import { render, staticRenderFns } from "./teacherlist.vue?vue&type=template&id=0106922e&"
import script from "./teacherlist.vue?vue&type=script&lang=js&"
export * from "./teacherlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports